import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Navigation } from "./components/navigation";
import { Header } from "./components/header";
import { Features } from "./components/features";
import { About } from "./components/about";
import { Services } from "./components/services";
import { Gallery } from "./components/gallery";
import { Testimonials } from "./components/testimonials";
import { Team } from "./components/Team";
import { Contact } from "./components/contact";
import GoogleMap from "./components/map";
import { Career } from "./components/career";
import JsonData from "./data/data.json";
import axios from "axios";
import "./App.css";
import Footer from "./components/Footer";

const App = () => {
  const [buttonPopup, setButtonPopup] = useState(false);
  const [landingPageData, setLandingPageData] = useState({});
  const [headdata, setHeadData] = useState("");
  const [aboutdata, setAboutData] = useState([]);
  const [features, setFeatures] = useState([]);
  const [services, setServices] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [team, setTeam] = useState([]);
  const [images, setImages] = useState([]);
  const [careers, setCareers] = useState([]);

  const apikey = process.env.REACT_APP_API;

  const getHead = async () => {
    await axios.get(`${apikey}gethead`).then((response) => {
      setHeadData(response.data[0]);
    });
  };

  const getAbout = async () => {
    await axios.get(`${apikey}getabout`).then((response) => {
      setAboutData(response.data[0]);
    });
  };

  const getFeature = async () => {
    await axios.get(`${apikey}fetchfeaturetitle`).then((response) => {
      setFeatures(response.data);
    });
  };

  const getServices = async () => {
    await axios.get(`${apikey}fetchservicestitle`).then((response) => {

      setServices(response.data);
    });
  };

  const getTestimonials = async () => {
    await axios.get(`${apikey}fetchtestimonialstitle`).then((response) => {
      setTestimonials(response.data);
    });
  };

  const getTeam = async () => {
    await axios.get(`${apikey}fetchteamtitle`).then((response) => {
      setTeam(response.data);
    });
  };

  const getimages = async () => {
    await axios.get(`${apikey}fetchgalleryimage`).then((response) => {
      setImages(response.data);
    });
  };

  const getcareers = async () => {
    await axios.get(`${apikey}careersfetch`).then((response) => {
      setCareers(response.data);
    });
  };

  useEffect(() => {
    getHead();
    getcareers();
    getAbout();
    getFeature();
    getServices();
    getTestimonials();
    getTeam();
    getimages();
    setLandingPageData(JsonData);
  }, []);

  return (
    <Router>
      <Navigation setTrigger={setButtonPopup} trigger={buttonPopup} />

      <Routes>
        <Route path="/" element={<Header headdata={headdata} />} />
        <Route path="/about" element={<About aboutdata={aboutdata} />} />
        <Route path="/features" element={<Features features={features} />} />
        <Route path="/services" element={<Services services={services} />} />
        <Route path="/gallery" element={<Gallery images={images} />} />
        {/* <Route path="/testimonials" element={<Testimonials testimonials={testimonials} />} /> */}
        <Route path="/team" element={<Team team={team} />} />
        <Route path="/map" element={<GoogleMap />} />
        <Route path="/contact" element={<Contact data={landingPageData.Contact} />} />
        <Route
          path="/careers"
          element={<Career trigger={buttonPopup} setTrigger={setButtonPopup} career={careers} />}
        />
        {/* 404 fallback */}
        <Route path="*" element={<h2 style={{ textAlign: "center", marginTop: "50px" }}>Page Not Found</h2>} />
      </Routes>
      <Footer/>
    </Router>
  );
};

export default App;
